export enum PayeeFilterType {
  Name = 0,
  Contact,
  Email,
  PadStatus,
  Type,
}

export enum PayeeContactType {
  Customer,
  Supplier,
}

export enum PayeeContactTabsType {
  All = 'All Contacts',
  Suppliers = 'Suppliers',
  Customers = 'Customers',
}
